import type { HttpMessages } from '../types';

const messages: HttpMessages = {
  'httpRequestResult.response': '返回结果',
  'httpRequestResult.noResponseDesc': '点击"发送"按钮获取返回结果',
} as const;

export default messages;
